module.exports = __webpack_public_path__ + "static/media/like-notify.c200e1f3.svg";